import React from 'react'
import { withParsedContext } from '../../withJSSContext'
import { TFunction } from 'i18next'

interface MagazinesRelatedArtistsModuleProps {
  t: TFunction
  parsedFields: {}
  parsedRouteFields: {}
  parsedSitecoreContext: {}
}

const MagazinesRelatedArtistsModule: React.FC<MagazinesRelatedArtistsModuleProps> = () => {
  // TODO - component needs to be created
  return null
}

export default withParsedContext(MagazinesRelatedArtistsModule as React.FC)
